'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import Box, { BoxProps } from '../kit/box'

/* -----------------------------------------------------------------------------
 * Content
 * -------------------------------------------------------------------------- */

export type ContentProps = BoxProps & {}

function Content(rest: ContentProps) {
  return <Box width='100%' maxWidth={1024} p={'24'} {...rest} />
}

export default Content
